import { personalContactApi } from '@/api'
import { PersonalContact } from '@/models'

export default {
  namespaced: true,

  state: {
    personalContact: new PersonalContact()
  },

  getters: {},

  mutations: {
    setPersonalContact(state, payload) {
      state.personalContact = payload
    },

    clearState(state) {
      state.personalContact = new PersonalContact()
    }
  },

  actions: {
    async GET_PERSONAL_CONTACT({ commit, dispatch }, payload) {
      try {
        const data = await personalContactApi.findAllByPersonalData({id: payload.id})
        if (data.id) {
          commit('setPersonalContact', data)
        }
      } catch (e) {
        console.log(e)
        return Promise.reject(e)
      }
    },

    async CREATE_PERSONAL_CONTACT({ commit }, payload) {
      try {
        const data = await personalContactApi.create(payload)
        if (data.id) {
          commit('setPersonalContact', data)
        }
        return data
      } catch (e) {
        console.log(e)
        return Promise.reject(e)
      }
    },

    async UPDATE_PERSONAL_CONTACT({ commit }, payload) {
      try {
        commit('setPersonalContact', payload)
        return await personalContactApi.update(payload)
      } catch (e) {
        console.log(e)
        return Promise.reject(e)
      }
    }
  }
}
